export const environment = {
    production: false,
    apiUrl: 'https://pngtiapidev.clavisco.com/api/',
    name: 'Pan American GTI',
    env: 'Development',
    recatchaSiteKey: '6Leso_QrAAAAAD7OHYr1dt3xsDmdt1xO9BALePG6',
    logrocket: ''
  }